import { Box, styled, Grid, Typography } from '@mui/material';
import LoginCard from '../components/LoginCard';
import LoginCardExternal from '../components/LoginCardExternal';
import sanMiguelLogo from '../assets/login-logo.png';

// Icons
import Envio from '../assets/icons/envio-icon.jsx';
import Multas from '../assets/icons/multas-icon.jsx';
import Tasas from '../assets/icons/tasas-icon.jsx';

//import girl from '../assets/login-background-patentes.jpg';
import girl from '../assets/login-background.png';
import LoginButton from '../components/LoginButton';
import { authenticate } from '../features/login/loginSlice';
import { store } from '../store';


const Background = styled(Box)(({ theme }) => ({
  //backgroundColor: '#28b3e5',
  backgroundImage: `linear-gradient(rgba(54, 183, 232, 0.3), rgba(54, 183, 232, 0.3)), url(${girl})`,
  backgroundRepeat: 'no-repeat',
  //backgroundSize: 'contain',
  backgroundSize: 'cover',
  //backgroundPositionX: 'center',
  height: '100vh',

  display: 'none',

  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function Login() {
  const handleLogin = (provider: string) => {
    store.dispatch(authenticate(provider))
      .unwrap()
      .then(response => {
        window.location.replace(response.url);
      });
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={6}
        style={{
          paddingLeft: '80px',
          paddingRight: '80px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Grid container my={5}>
          <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img
              src={sanMiguelLogo}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Grid>
        </Grid>

        <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>

          <Grid item md={12} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <LoginCard
              icon={<Tasas />}
              title={'Pagá tu tasa'}
              description={'Descargala y pagá desde donde estés sin loguearte'}
              button={'PAGAR AHORA'}
              link={'/paga-tu-tasa'}
            />
          </Grid>

          <Grid item md={12} lg={4} sx={{ display: import.meta.env.VITE_EPAGOS === 'true' ? 'none' : 'flex', justifyContent: 'center' }} >
            <LoginCardExternal
              icon={<Multas />}
              title={'Pagá tus multas'}
              description={
                'Consultá y abona las multas de tu rodado'
              }
              button={'PAGAR AHORA'}
              link={'https://juzgadodefaltas.msm.gov.ar/ords/smi/f?p=204'}
            />
          </Grid>

          <Grid item md={12} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <LoginCard
              icon={<Envio />}
              title={'Boleta por mail'}
              description={
                'Suscribite y recibí tu boleta por correo electrónico'
              }
              button={'SUSCRIBIRME'}
              link={'/boleta'}
            />
          </Grid>

        </Grid>

        <Grid sx={{ display: import.meta.env.VITE_EPAGOS === 'true' ? 'none' : 'flex' }} container my={10}>

          <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h2" mb={'2rem'} mt={'1rem'}>
              Iniciar Sesión
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <LoginButton title={'ARCA'} handleClick={() => handleLogin('afip')} />
            <LoginButton title={'ANSES'} handleClick={() => handleLogin('anses')} />
          </Grid>

        </Grid>

      </Grid>
      <Grid item xs={6}>
        <Background />
      </Grid>
    </Grid>
  );
}
